import { formatDateDDMMYYYY, formatTimestampDDMMYYYY, toISODate, getTodayISO } from '../../utils/dateHelpers';

/**
 * Task card component for displaying task information
 */
export function TaskCard({ task, locations, users, onSelect }) {
  const location = locations.find(l => l.id === task.locationId);
  const assignee = users.find(u => u.id === task.assigneeId);

  const today = getTodayISO();
  const isOverdue = task.status === 'overdue' || (task.status === 'open' && task.dueDate < today);
  const isToday = task.dueDate === today;

  const hasSteps = task.steps && task.steps.length > 0;
  const stepsCompleted = hasSteps ? task.steps.filter(s => s.completed).length : 0;
  const stepsTotal = hasSteps ? task.steps.length : 0;

  return (
    <div
      className={`task-card status-${task.status} ${isOverdue ? 'overdue' : ''} ${isToday ? 'today' : ''}`}
      onClick={onSelect}
    >
      <div className="task-card-header">
        <h4>{task.title}</h4>
        <div className="task-header-badges">
          {hasSteps && (
            <span className={`badge badge-steps ${task.status === 'completed-with-issues' ? 'with-issues' : ''}`}>
              {stepsCompleted}/{stepsTotal}
            </span>
          )}
          <span className={`badge badge-${task.status} ${task.status === 'completed-with-issues' ? 'with-issues' : ''}`}>
            {task.status === 'open' ? 'Offen' :
             task.status === 'overdue' ? 'Überfällig' :
             task.status === 'completed-with-issues' ? '(Teil-)Erledigt' :
             'Erledigt'}
          </span>
        </div>
      </div>

      <p className="task-description">{task.description}</p>

      <div className="task-card-meta">
        <div className="meta-item">
          <i className="fas fa-map-marker-alt"></i>
          <span>{location?.name || 'Unbekannt'}</span>
        </div>

        {assignee && (
          <div className="meta-item">
            <i className="fas fa-user"></i>
            <span>{assignee.displayName}</span>
          </div>
        )}

        <div className="meta-item">
          <i className="fas fa-calendar"></i>
          <span>{formatDateDDMMYYYY(task.dueDate)}</span>
        </div>

        {task.photoRequired && (
          <div className="meta-item">
            <i className="fas fa-camera"></i>
            <span>Foto erforderlich</span>
          </div>
        )}
      </div>

      {(task.status === 'completed' || task.status === 'completed-with-issues') && task.completedAt && (
        <div className="task-completed-info">
          <i className="fas fa-check"></i>
          Erledigt am {formatTimestampDDMMYYYY(task.completedAt)}
          {(() => { const cd = toISODate(task.completedAt); return cd && task.dueDate < cd; })() && (
            <span className="overdue-badge">⚠️ Verspätet</span>
          )}
          {task.status === 'completed-with-issues' && (
            <span className="issues-note"> (unvollständig)</span>
          )}
        </div>
      )}
    </div>
  );
}
